module.exports = __webpack_public_path__ + "static/fonts/impact.f129020.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/impact.ttf
// module id = bFdo
// module chunks = 1